import {
  FormControl,
  FormLabel,
  FormErrorMessage,
  Spinner,
} from "@chakra-ui/react";
import { FieldProps } from "formik";
import { useState } from "react";
import Select from "react-select";

interface Option {
  [key: string]: any;
}

interface SelectComponentProps {
  label: string;
  placeholder?: string;
  options: Option[];
  valueKey: string;
  labelKey: string;
  readOnly?: boolean;
  isLoading?: boolean;
  returnObject?: boolean;
}

export default function SelectComponent({
  field,
  form,
  label,
  placeholder,
  options,
  valueKey,
  labelKey,
  readOnly = false,
  isLoading = false,
  returnObject = false,
}: SelectComponentProps & FieldProps) {
  const error = form.errors[field.name];
  const touched = form.touched[field.name];
  const [menuIsOpen, setMenuIsOpen] = useState(false);

  const customStyles = {
    control: (provided: any) => ({
      ...provided,
      backgroundColor: readOnly ? "#f9f9f9" : "white",
      fontFamily: "'Lexend Deca', sans-serif",
    }),
    option: (provided: any, state: any) => ({
      ...provided,
      backgroundColor: state.isSelected
        ? "#2684FF"
        : state.isFocused
        ? "#E6F0FF"
        : "white",
      color: state.isSelected ? "white" : "black",
      fontFamily: "'Lexend Deca', sans-serif",
    }),
  };

  const getValue = () => {
    return field.value
      ? options.find((option: Option) =>
          returnObject
            ? option[valueKey] === field.value[valueKey]
            : option[valueKey] === field.value
        )
      : null;
  };

  const handleChange = (selected: Option | null) => {
    const value = returnObject ? selected : selected?.[valueKey];
    form.setFieldValue(field.name, value);
    setMenuIsOpen(false);
  };

  return (
    <FormControl isInvalid={!!error && !!touched}>
      <FormLabel htmlFor={field.name} fontFamily="'Lexend Deca', sans-serif">
        {label}
      </FormLabel>
      {isLoading ? (
        <Spinner />
      ) : (
        <Select
          id={field.name}
          placeholder={placeholder}
          isDisabled={readOnly}
          options={options}
          getOptionLabel={(option: Option) => option[labelKey]}
          getOptionValue={(option: Option) => option[valueKey]}
          value={getValue()}
          onChange={handleChange}
          styles={customStyles}
          menuIsOpen={menuIsOpen}
          onMenuOpen={() => setMenuIsOpen(true)}
          onMenuClose={() => setMenuIsOpen(false)}
        />
      )}
      {touched && typeof error === "string" && (
        <FormErrorMessage fontFamily="'Lexend Deca', sans-serif">
          {error}
        </FormErrorMessage>
      )}
    </FormControl>
  );
}
